import './onderwerp-met-video.scss'
console.log('wat');
const closeDialog = (dialog, triggerButton) => {
	dialog.setAttribute('aria-hidden', 'true');
	dialog.close();

	if (triggerButton instanceof HTMLElement) {
		triggerButton.focus();
	}
};

const openDialog = (modal, triggerButton) => {
    console.log('open dialog function');
	modal.setAttribute('aria-hidden', 'false');

	const closeButton = modal.querySelector('.o-onderwerpMetVideo__modal-close');
	if (closeButton) {
		closeButton.focus();
		return;
	}

	const firstFocusableElement = modal.querySelector(
		'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
	);

	if (firstFocusableElement instanceof HTMLElement) {
		firstFocusableElement.focus();
		return;
	}

	modal.focus();
};

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.o-onderwerpMetVideo').forEach((block) => {
		const dialog = block.querySelector('.o-onderwerpMetVideo__dialog');
		const openButton = block.querySelector('.js--open-dialog');


		const closeButton = dialog.querySelector('.o-onderwerpMetVideo__dialog-close');
		const overlay = dialog.querySelector('.o-dialog__overlay');

		openButton.addEventListener('click', () => {
            console.log('open dialog');
			openDialog(dialog, openButton);
		});

		if (closeButton) {
			closeButton.addEventListener('click', () => {
				closeDialog(dialog, openButton);
			});
		}

		if (overlay instanceof HTMLElement) {
			overlay.addEventListener('click', () => {
				closeDialog(dialog, openButton);
			});
		}

		dialog.addEventListener('cancel', (event) => {
			event.preventDefault();
			closeDialog(dialog, openButton);
		});

		dialog.addEventListener('click', (event) => {
			if (event.target === dialog) {
				closeDialog(dialog, openButton);
			}
		});

		dialog.addEventListener('close', () => {
			dialog.setAttribute('aria-hidden', 'true');
		});
	});
});